// @flow

import * as React from "react"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import throttle from "lodash/throttle"

import {setBabiesQuery, fetchBabiesPaged} from "../actions/babies"
import type {Dispatch} from "../types"

type Props = {
  dispatch: Dispatch,
  t: any,
}

const SEARCH_TIMEOUT = 500

class BabiesSearch extends React.Component<Props> {
  handleChange: (SyntheticInputEvent<HTMLInputElement>) => void
  throttledSearchQuery: (arg0: any) => void

  static defaultProps = {}

  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.throttledSearchQuery = throttle(this.doSearch, SEARCH_TIMEOUT, {
      leading: false,
    })
  }

  handleChange(e: SyntheticInputEvent<HTMLInputElement>) {
    const {value} = e.currentTarget
    this.throttledSearchQuery.cancel()
    this.throttledSearchQuery(value)
  }

  doSearch(q) {
    this.props.dispatch(setBabiesQuery(q))
    this.props.dispatch(fetchBabiesPaged())
  }

  render() {
    const {t} = this.props
    return (
      <div className="babies-filters filters mr-2">
        <span className="text-gray mr-2">
          {t("dashboard.babies.search.label")}
        </span>
        <input
          type="text"
          name="q"
          className="filter form-control form-control-sm"
          onChange={this.handleChange}
        />
      </div>
    )
  }
}

export default withTranslation()(connect()(BabiesSearch))
